import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import ApplicationRoutes from "./routing/ApplicationRoutes";
import Snackbar from "./Providers/SnackbarProvider";
import Theme from "./theme";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClient, QueryClientProvider } from "react-query";

import { publishableKey } from "./config/constants";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const queryClient = new QueryClient();

const App = () => {
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   const storedToken = localStorage.getItem(ACCESS_TOKEN);
  //   if (storedToken && storedToken.length > 0) {
  //     dispatch(authActions.login());
  //   }
  // }, [dispatch]);
  return (
    <BrowserRouter>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Theme>
          <QueryClientProvider client={queryClient}>
            <Snackbar>
              <ApplicationRoutes />
            </Snackbar>
          </QueryClientProvider>
        </Theme>
      </LocalizationProvider>
    </BrowserRouter>
  );
};

export default App;
